<nz-tag
  [ngClass]="pill.cssClass"
  nz-tooltip
  nzTooltipPlacement="bottom"
  [nzTooltipTitle]="pill.tooltip">
  {{ pill.label }}
</nz-tag>
